/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseManageTicket } from '../../models/api-response-manage-ticket';

export interface GetManageTicket$Params {
  requestId: string;
  canal: string;
  reference: string;
}

export function getManageTicket(http: HttpClient, rootUrl: string, params: GetManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
  const rb = new RequestBuilder(rootUrl, getManageTicket.PATH, 'get');
  if (params) {
    rb.query('requestId', params.requestId, {});
    rb.query('canal', params.canal, {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseManageTicket>;
    })
  );
}

getManageTicket.PATH = '/v1/api/ui/manage-ticket/get/{reference}';
